import React, { forwardRef, useState, useEffect } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
// import DatePicker from "react-datepicker";
import toast from "react-hot-toast";
import Moment from "moment";
import { DatePicker } from "antd";
import { CSVLink, CSVDownload } from "react-csv";
import { SyncLoader } from 'react-spinners';
// components
import Navbar from "../../Components/Navbar/Navbar";
import Table from "../../Components/TableTemplate/OneTable";
import PettyCashModal from "./PettyCashModal";
import PettyCashEditModal from "./PettyCashEditModal";
import Select from "react-select";

// api calls and utils
import {
  searchPettyCashTransactionDetails,
  getPettyCashInfo,
  approvePettyCashRequest,
} from "../../Helpers/apiCalls/PettyCash/PettyCashRegisterApi";

import { getAllExpenseType } from "../../Helpers/apiCalls/expensetypesApi";

import {
  getType,
  toastStyle,
  numberFormat,
  selectDropdownStyle,
  selectDropdownStyleWithPortal,
  firstDayOfMonth,
  lastDayOfMonth,
  formatDateNoTime,
} from "../../Helpers/Utils/Common";

import { usePersistedState } from "../../Helpers/Utils/UsePersistedState";

// css
import "./PettyCash.css";

const { RangePicker } = DatePicker;
/**
 *  Petty Cash Register component
 */

export default function PettyCash() {
  let navigate = useNavigate();
  const location = useLocation();
  // const [activeTab, setActiveTab] = useState("all-register");
  const accountType = getType();
  const [inactive, setInactive] = useState(true);
  const [pettyCashID] = useState("1");
  const [pettyCashInfo, setPettyCashInfo] = useState({});
  const [pettyCashTransactions, setPettyCashTransactions] = useState([]);
  // const [selectedTransactionType, setSelectedTransactionType] = useState(null);
  // const [selectedAccountType, setSelectedAccountType] = useState(null);
  const [accountTypes, setAccountTypes] = useState([]);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);

  const date = new Date();
  date.setDate(date.getDate() - 7);

  const nextDay = new Date();
  nextDay.setDate(nextDay.getDate());

  /* FILTER CONFIGS */
  // added change: used persisted state for data persistency check Helpers/UsePersistedState.js
  const [filterConfig, setFilterConfig] = usePersistedState("pettycash_filters", {
    tab: "all-register",
    transaction_type: "",
    account_type: "",
    date_from: firstDayOfMonth(),
    date_to: lastDayOfMonth(),
    type: "",
    status: "approved",
  });

  function filterPettyCashTransactions() {
    searchTransactionsApi();
  }

  useEffect(() => {
    filterPettyCashTransactions();
  }, [filterConfig]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");

    if (tab) {
      // setActiveTab(tab);
      setFilterConfig((prev) => ({
        ...prev,
        tab,
        status: tab === "all-register" ? "approved" : "request", // Set status based on tab
      }));
    }
  }, [location]);

  // const transactionTyepOptions = [
  //   { value: "", label: "All" },
  //   { value: "In", label: "Cash In" },
  //   { value: "Out", label: "Cash Out" },
  // ]
  const transactionTypeOptions = [
    { value: "", label: "All" },
    { value: "In", label: "Cash In" },
    { value: "Out", label: "Cash Out" },
  ];

  const excelHeaders = [
    { label: "Date", key: "date" },
    { label: "Transaction Type", key: "type" },
    { label: "From", key: "from" },
    { label: "Account Type", key: "expense_type_name" },
    { label: "Particulars", key: "particulars" },
    { label: "Cash In", key: "cashin_amount" },
    { label: "Cash Out", key: "cashout_amount" },
    { label: "Balance", key: "current" },
    { label: "Added By", key: "added_by_name" },
    { label: "Added On", key: "added_on" },
];

  const [showLoader, setShowLoader] = useState(false);

  async function searchTransactionsApi() {
    setShowLoader(true);
    var params = {
      petty_cash_id: pettyCashID,
      ...filterConfig,
      type: filterConfig.transaction_type, // Pass the type in the payload
      // Temporarily remove backend filtering to test client-side filtering
      // expense_type_id: filterConfig.account_type, // Pass the account type in the payload
    };

    // Debug: Log the parameters being sent to API
    console.log("Search Parameters:", params);

    const response = await searchPettyCashTransactionDetails(params);
    if (response) {
      if (response.status === "error") {
        if (response.data) {
          toast.error(response.data.response, {
            style: toastStyle(),
          });
        }
      } else if (response.status === "success") {
        var newData = response.history.map((data, index) => {
        var newData = data;
        newData.bank_name = data.bank_name ? data.bank_name : " ";
        newData.particulars = data.particulars ? data.particulars : " ";
        newData.remarks = data.remarks ? data.remarks : " ";
          // Debug: Log the first transaction to see available fields
          if (index === 0) {
            console.log("Sample transaction data:", data);
            console.log("Available fields:", Object.keys(data));
          }

          // For old data where bank_name is null, use the 'from' field instead
          if (data.bank_name == null || data.bank_name === "" || data.bank_name === " ") {
            newData.particulars = (data.from ? data.from : "") + " " + newData.particulars;
          } else {
            newData.particulars = data.bank_name + " " + newData.particulars;
          }

          if (newData.type === "out") {
            newData.cashin_amount = "";
            newData.cashout_amount = numberFormat(newData.amount);
          } else {
            newData.cashin_amount = numberFormat(newData.amount);
            newData.cashout_amount = "";
          }
          newData.date = formatDateNoTime(data.date);
          newData.added_on = formatDateNoTime(data.added_on);
          newData.formattedAddedBy = data.added_by_name + " " + formatDateNoTime(data.added_on);

          newData.current = numberFormat(newData.current);

          return newData;
        });
        newData = newData.sort((transaction_1, transaction_2) => {
          return Moment(transaction_1.date).isBefore(transaction_2.date);
        });

        // Client-side filtering by account type since backend doesn't support it
        if (filterConfig.account_type && filterConfig.account_type !== "") {
          console.log("Original data count:", newData.length);
          console.log("Filtering by account_type ID:", filterConfig.account_type);

          // Find the selected account type name from the accountTypes options
          const selectedAccountType = accountTypes.find(type => type.value.toString() === filterConfig.account_type.toString());
          const selectedAccountTypeName = selectedAccountType ? selectedAccountType.label : "";
          console.log("Selected account type name:", selectedAccountTypeName);

          // Filter by expense_type_name field (which is used in the table)
          const filteredData = newData.filter(transaction => {
            const matchesByName = transaction.expense_type_name && transaction.expense_type_name === selectedAccountTypeName;
            const matchesById = transaction.expense_type_id && transaction.expense_type_id.toString() === filterConfig.account_type.toString();

            console.log("Transaction:", {
              id: transaction.id,
              expense_type_name: transaction.expense_type_name,
              expense_type_id: transaction.expense_type_id,
              matchesByName: matchesByName,
              matchesById: matchesById
            });

            return matchesByName || matchesById;
          });

          console.log("Filtered data count:", filteredData.length);
          newData = filteredData;
        }
        if (response.petty_cash) {
          setPettyCashInfo({ ...response.petty_cash });
        }
        setPettyCashTransactions(newData);
      } else {
        if (response.eror) {
          toast.error(response.eror, { style: toastStyle() });
        }
      }
    }
    setShowLoader(false);
  }

  async function fetchPettyCashInfo() {
    const response = await getPettyCashInfo({ petty_cash_id: pettyCashID });

    if (response.error) {
      toast.error(response.error.data.messages.error, {
        style: toastStyle(),
      });
    } else {
      if (response.status === "error") {
        toast.error(response.error.data.messages.error, {
          style: toastStyle(),
        });
      } else if (response.status === "success") {
        setPettyCashInfo({ ...response["data"] });
      } else {
        var errMsg = response.error;
        toast.error(errMsg, { style: toastStyle() });
      }
    }
  }

  async function fetchAccountTypes() {
    console.log("fetchAccountTypes function called");
    try {
      const response = await getAllExpenseType();
      console.log("Account Types Response:", response);
      if (response && response.data) {
        const types = response.data.map((type) => ({
          label: type.name,
          value: type.id,
        }));
        const accountTypeOptions = [{ label: "All Account Types", value: "" }, ...types];
        console.log("Account Type Options:", accountTypeOptions);
        setAccountTypes(accountTypeOptions);
      }
    } catch (error) {
      console.error("Error fetching account types:", error);
      setAccountTypes([{ label: "All Account Types", value: "" }]);
    }
  }

  async function handleApprovePettyCashRequest() {
    const response = await approvePettyCashRequest(
      selected.petty_cash_items[0].petty_cash_detail_id
    );
    if (response.error) {
      toast.error(response.error.data.messages.error, {
        style: toastStyle(),
      });
    } else {
      if (response.status === "error") {
        toast.error(response.error.data.messages.error, {
          style: toastStyle(),
        });
      } else if (response.response === "Cashout approved") {
        toast.success("Successfully Approved Petty Cash Request", {
          style: toastStyle(),
        });

        // Update the petty cash transactions state to reflect the approved request
        setPettyCashTransactions((prevTransactions) =>
          prevTransactions.filter(
            (transaction) =>
              transaction.id !== selected.petty_cash_items[0].petty_cash_detail_id
          )
        );

        // Close the modal
        handleCloseApproveModal();

        // Ensure the tab remains consistent
        setFilterConfig((prev) => ({
          ...prev,
          // tab: activeTab,
          // status: activeTab === "all-register" ? "approved" : "request",
          status: prev.tab === "all-register" ? "approved" :  "request",  
        }));
      } else {
        var errMsg = response.error;
        toast.error(errMsg, { style: toastStyle() });
      }
    }
  }

  useEffect(() => {
    console.log("PettyCash component mounted - fetching data...");
    // fetchPettyCashInfo();
    fetchAccountTypes();
  }, []);

  /* approve modal handler */
  const [showApproveModal, setShowApproveModal] = useState(false);
  const handleShowApproveModal = () => setShowApproveModal(true);
  const handleCloseApproveModal = () => setShowApproveModal(false);

  function handleToCSV() {
    return (
      <CSVLink
        data={pettyCashTransactions.slice()}
        headers={excelHeaders}
        filename={`PettyCash_${Moment().format("YYYY-MM-DD")}.csv`}
        style={{ textDecoration: "none", color: "#ffffff" }}
      >
        Export to CSV
      </CSVLink>
    );
  }

  const handleTabSelect = (tabKey) => {
    const updatedConfig = {
      ...filterConfig,
      tab: tabKey,
      transaction_type: "", // Reset the transaction type filter
      account_type: "", // Reset the account type filter
      date_from: firstDayOfMonth(),
      date_to: lastDayOfMonth(),
    };
  

    if (tabKey === "all-register") {
      updatedConfig.status = "approved";
    } else if (tabKey === "request") {
      updatedConfig.status = "request";
      updatedConfig.date_from = "";
      updatedConfig.date_to = "";
    }
  

    // setSelectedTransactionType(null); // Reset the dropdown value
    // setSelectedAccountType(null); // Reset the account type dropdown value
    setFilterConfig(updatedConfig);
    // setActiveTab(tabKey);
  };

  const [selected, setSelected] = useState({});


  function handleApprove(row) {
    setSelected(row);
    handleShowApproveModal();
  }

  function handleRowClick(row) {
    setSelectedTransaction(row);
    setSelected(row);
    setShowEditModal(true);
  }

  function handleCloseEditModal() {
    setShowEditModal(false);
    setSelectedTransaction(null);
  }

  function handleUpdateTransaction() {
    // Refresh the transactions list
    searchTransactionsApi();
  }

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"PETTY CASH"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* headers */}
        <Row className="mb-4">
          <Col xs={6}>
            <h1 className="page-title">PETTY CASH REGISTER</h1>
             <h4 className="page-subtitle">
              {" "}
              Current Petty Cash:{" "}
              {showLoader || pettyCashInfo.current_petty_cash == null ? (
                <span className="ms-2 d-inline-flex align-items-center">
                  <SyncLoader color="#5ac8e1" size={8} />
                </span>
              ) : (
                <>&nbsp;{"PHP "}{numberFormat(pettyCashInfo.current_petty_cash)}</>
              )}
            </h4>
          </Col>
          <Col xs={6} className="d-flex justify-content-end">
            {accountType !== "liason_officer" && (
              <>
                <button 
                className="add-btn text-center">
                  {handleToCSV()}
                </button>

                <button
                  className="add-btn"
                  onClick={() => navigate("/pettycash/cashin")}
                >
                  Cash In
                </button>
              </>
            )}
            <button
              className="add-btn"
              onClick={() => navigate("/pettycash/cashout")}
            >
              Cash Out
            </button>
          </Col>
        </Row>
        
        <Tabs
          // activeKey={activeTab}
          activeKey={filterConfig.tab}
          id="petty-cash-tabs"
          onSelect={handleTabSelect}
        >
          <Tab eventKey="all-register" title="ALL REGISTER">
            {/* filters */}
            <div className="my-2 ms-2 PO-filters PI-filters d-flex">
              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Select Transaction Type"
                styles={selectDropdownStyleWithPortal}
                // value={selectedTransactionType}
                value={transactionTypeOptions.find((o) => o.value === filterConfig.transaction_type) ?? null}
                // options={[
                //   { value: "", label: "All" },
                //   { value: "In", label: "Cash In" },
                //   { value: "Out", label: "Cash Out" },
                // ]}
                options={transactionTypeOptions}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                onChange={(e) => {
                  // setSelectedTransactionType(e);
                  // setFilterConfig((prev) => {
                  //   return { ...prev, transaction_type: e.value };
                  // });
                  setFilterConfig((prev) => ({ ...prev, transaction_type: e.value }));
                }}
              />

              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Select Account Type"
                styles={selectDropdownStyleWithPortal}
                // value={selectedAccountType}
                value={accountTypes.find((o) => o.value === filterConfig.account_type) ?? null}
                options={accountTypes}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                onChange={(e) => {
                  // console.log("Account Type Selected:", e);
                  // setSelectedAccountType(e);
                  // setFilterConfig((prev) => {
                  //   const newConfig = { ...prev, account_type: e.value };
                  //   console.log("Updated Filter Config:", newConfig);
                  //   return newConfig;
                  // });
                  setFilterConfig((prev) => ({ ...prev, account_type: e.value }));
                }}
              />

              <RangePicker
                placeholder={[
                  filterConfig.date_from ?? firstDayOfMonth(), 
                  filterConfig.date_to ?? lastDayOfMonth()
                ]} 
                onChange={(e) => {
                  if (e) {
                    setFilterConfig((prev) => ({
                      ...prev,
                      date_from: e[0].format('YYYY-MM-DD'),
                      date_to: e[1].format('YYYY-MM-DD'),
                    }))
                  } else {
                    setFilterConfig((prev) => ({
                      ...prev,
                      date_from: firstDayOfMonth(),
                      date_to: lastDayOfMonth(),
                    }))
                  }
                }}
              />
            </div>

            {/* content */}
            <div className="pettycash-tbl">
              <Table
                tableHeaders={[
                  // "-",
                  "DATE",
                  //"ACCOUNT TYPE",
                  "ACCOUNT TYPE",
                  // "FROM",
                  "PARTICULARS",
                  // "REQ BY",
                  "CASH IN",
                  "CASH OUT",
                  "BALANCE",
                  "ADDED BY",
                  "REMARKS",
                  // "ADDED ON",
                ]}
                headerSelector={[
                  // "-",
                  "date",
                  //"account  type",
                  "expense_type_name",
                  // "from",
                  "particulars",
                  // "requested_by_name",
                  "cashin_amount",
                  "cashout_amount",
                  "current",
                  "formattedAddedBy",
                  "remarks",
                  // "added_on",
                ]}
                tableData={pettyCashTransactions}
                // ViewBtn={(row) => ViewBtn(row)}
                showLoader={showLoader}
                withActionData={false}
                rowClickHandler={handleRowClick}
              />
            </div>
            <div className="mb-2" />
          </Tab>
        </Tabs>
      </div>
      <PettyCashModal
        show={showApproveModal}
        hide={handleCloseApproveModal}
        type="approve"
        handler={handleApprovePettyCashRequest}
      />
      <PettyCashEditModal
        show={showEditModal}
        onHide={handleCloseEditModal}
        transaction={selectedTransaction}
        onUpdate={handleUpdateTransaction}
      />
    </div>
  );
}